import { Construction } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';

interface PhasePlaceholderProps {
  title: string;
  phaseNote: string;
}

/**
 * Phase 0 scope explicitly keeps feature pages as "clean placeholder shells."
 * This component is that shell — used by every dashboard/owner page that
 * doesn't have real functionality yet, so every such page is honest about
 * its own status rather than showing fabricated data.
 */
export function PhasePlaceholder({ title, phaseNote }: PhasePlaceholderProps) {
  return (
    <div className="max-w-2xl">
      <h1 className="text-h1 text-text-primary mb-1">{title}</h1>
      <p className="text-small text-text-tertiary mb-8">{phaseNote}</p>
      <EmptyState
        icon={Construction}
        title="Not built yet"
        description="This section is part of the planned Dem Web experience but has no functionality connected yet. See docs/IMPLEMENTATION_PLAN.md for the build phase this ships in."
      />
    </div>
  );
}
